module.exports = __webpack_public_path__ + "static/media/shorts-reject-icon-2.75314af7.png";